import "./Shoerack.css"
import Product1 from "./Product1"
import Wm1 from "../images/rack1.webp"
import Wm2 from "../images/rack2.webp"
import Wm3 from "../images/rack3.jpg"
import Wm4 from "../images/rack4.webp"
import Wm5 from "../images/rack5.webp"
import Wm6 from "../images/rack6.webp"
import Wm7 from "../images/rack7.webp"
import Wm8 from "../images/rack8.webp"
import Wm9 from "../images/rack9.jpg"





export default function Shoerack() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Wm9} /></div>
          
                   

      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="rack1"prdName="RACK" img={Wm1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1  id="rack2"prdName="WOOD RACK" img={Wm2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 id="rack3" prdName="STEEL RACK" img={Wm3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="rack4" prdName="PLYWOOD" img={Wm4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="rack5" prdName="DESK" img={Wm5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="rack6" prdName="SHOE STAND
            " img={Wm6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="rack7" prdName="SHOE RACK" img={Wm7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="rack8"prdName="SHOE RACK" img={Wm8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}